import { CompanyInfoCard } from "./components/CompanyInfoCard";
import { ResourcesSection } from "./components/ResourcesSection";
import { WhatsappBanner } from "./components/WhatsappBanner";
import { DeleteAccountSection } from "./components/DeleteAccountSection";
import { LanguageSection } from "./components/LanguageSection";
import { ContractSection } from "./components/ContractSection";
import { ScheduleExceptionsSection } from "./components/ScheduleExceptionsSection";
import { InsuranceProvidersSection } from "./components/InsuranceProvidersSection";
import { useLanguage } from "../../contexts/LanguageContext";
import { settingsLabels } from "./labels";

export default function SettingsPage() {
  const { lang } = useLanguage();
  const t = settingsLabels[lang].pageHeader;

  return (
    <div className="mx-auto w-full max-w-5xl p-4 md:p-6 space-y-6 animate-in fade-in duration-500">
      <div className="flex items-center justify-between mb-8">
        <div className="space-y-1">
          <h1 className="text-2xl font-bold text-neutral-800 tracking-tight">{t.title}</h1>
          <p className="text-[10px] font-bold text-neutral-400 uppercase tracking-widest">
            {t.description}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        <div className="md:col-span-2 lg:col-span-3">
          <WhatsappBanner />
        </div>
        
        <div className="md:col-span-2 lg:col-span-3">
          <CompanyInfoCard />
        </div>

        <div className="md:col-span-2 lg:col-span-3 grid grid-cols-1 md:grid-cols-2 gap-6">
          <ResourcesSection />
          <ScheduleExceptionsSection />
          <ContractSection />
          <InsuranceProvidersSection />
        </div>

        <div className="md:col-span-2 lg:col-span-3 grid grid-cols-1 md:grid-cols-2 gap-6">
          <LanguageSection />
          <DeleteAccountSection />
        </div>
      </div>
    </div>
  );
}
